import React from "react";
import PropTypes from "prop-types";
import {APanel} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {Trans} from "react-i18next";
import css from "./MetricsCard.module.scss";

const MetricsCard = ({
  i18nKey = "",
  count = 0,
  filters,
  handleSearch,
  className,
  active
}) => {
  const handleCardClick = () => {
    handleSearch(filters);
  };
  return (
    <APanel
      className={classNames(
        "metrics-card",
        css.metricsCard,
        className,
        "px-3 py-2",
        {[css.activeState]: active}
      )}
      data-testid={"MetricsCard-Panel"}
      onClick={handleCardClick}>
      <Trans
        i18nKey={i18nKey}
        values={{count: count}}
        components={{
          num: <span className={classNames(css.count, "mr-1")} />
        }}
      />
    </APanel>
  );
};

MetricsCard.propTypes = {
  i18nKey: PropTypes.string.isRequired,
  count: PropTypes.number,
  filters: PropTypes.object,
  handleSearch: PropTypes.func,
  active: PropTypes.bool.isRequired
};

export default MetricsCard;
